module.exports = __webpack_public_path__ + "images/marketing/crm-best-of-2014-g2-crowd.png";